/**
 * UPT-2124 J4a (spec `web/SPEC-UPT-2124-J4.md` §2 n° 2) — les destinations de `ui_navigate` : les entrées du MENU DE NAVIGATION au runtime
 * (`useRuntimeNavigation`), par libellé — jamais une adresse libre. Aplatit l'arbre (liens, et groupes qui portent une route), écarte les nœuds
 * désactivés, masqués, externes ou sans route concrète (jetons `:workspaceId` restants), traduit les libellés, garde le chemin dans le menu
 * (« Finance › Budgets ») pour départager deux entrées de même nom.
 */
import type { NavigationNode } from '@/types/navigation_management';
import { guardLabel } from '@/utils/i18nRenderGuard';
import type { UiNavEntry } from './uiTools';

const TRAIL_SEPARATOR = ' › ';

export const flattenNavigationEntries = (nodes: readonly NavigationNode[], translate: (id: string) => string): UiNavEntry[] => {
  const entries: UiNavEntry[] = [];
  const walk = (list: readonly NavigationNode[], trail: string[]): void => {
    list.forEach((node) => {
      if (node.kind === 'separator' || !node.enabled || !node.showInNavigation) return;
      const label = guardLabel(node.label ?? node.key, translate);
      const path = node.routePath ?? '';
      if (label && node.kind !== 'external-link' && path.startsWith('/') && !path.includes(':')) {
        entries.push({ label, path, trail: [...trail, label].join(TRAIL_SEPARATOR) });
      }
      if (node.children.length > 0) walk(node.children, label ? [...trail, label] : trail);
    });
  };
  walk(nodes, []);
  return entries;
};
